/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const listUsers = /* GraphQL */ `query ListUsers($limit: Int, $nextToken: String) {
  listUsers(limit: $limit, nextToken: $nextToken) {
    items {
      id
      email
      name
      userType
      odooId
      customerId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListUsersQueryVariables, APITypes.ListUsersQuery>;
export const getUser = /* GraphQL */ `query GetUser($id: ID!) {
  getUser(id: $id) {
    id
    email
    name
    userType
    odooId
    customerId
    __typename
  }
}
` as GeneratedQuery<APITypes.GetUserQueryVariables, APITypes.GetUserQuery>;
export const getDictionnary = /* GraphQL */ `query GetDictionnary($id: ID!) {
  getDictionnary(id: $id) {
    id
    type
    value
    customerId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDictionnaryQueryVariables,
  APITypes.GetDictionnaryQuery
>;
export const listDictionnarys = /* GraphQL */ `query ListDictionnarys(
  $filter: ModelDictionnaryFilterInput
  $limit: Int
  $nextToken: String
) {
  listDictionnarys(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      type
      value
      customerId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDictionnarysQueryVariables,
  APITypes.ListDictionnarysQuery
>;
export const dictionnaryByType = /* GraphQL */ `query DictionnaryByType(
  $type: String
  $sortDirection: ModelSortDirection
  $filter: ModelDictionnaryFilterInput
  $limit: Int
  $nextToken: String
) {
  dictionnaryByType(
    type: $type
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      type
      value
      customerId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.DictionnaryByTypeQueryVariables,
  APITypes.DictionnaryByTypeQuery
>;
export const getCandidateResume = /* GraphQL */ `query GetCandidateResume($id: ID!) {
  getCandidateResume(id: $id) {
    id
    owner
    submitted
    verified
    ExperienceSummary {
      TotalYearsOfManagementWorkExperience
      TotalYearsOfLowLevelManagementWorkExperience
      TotalMonthsOfWorkExperience
      ExecutiveBrief
      TotalMonthsOfLowLevelManagementWorkExperience
      TotalMonthsOfManagementWorkExperience
      TotalYearsOfMidLevelManagementWorkExperience
      TotalMonthsOfMidLevelManagementWorkExperience
      TotalYearsOfSeniorManagementWorkExperience
      TotalMonthsOfSeniorManagementWorkExperience
      ManagementRecord
      HighestEducationalLevel
      TotalYearsOfWorkExperience
      __typename
    }
    Achievements
    Available
    Competency {
      skillLevel
      skillUsed {
        value
        type
        __typename
      }
      skillProficiency
      Grade
      skillName
      description
      auth
      skillCount
      lastUsed
      CompetencyId {
        idOwner
        id
        __typename
      }
      TaxonomyId {
        idOwner
        description
        __typename
      }
      skillAliasArray
      __typename
    }
    ContactMethod {
      InternetWebAddress {
        content
        type
        __typename
      }
      InternetEmailAddress_main
      InternetEmailAddress_alt
      Telephone_home
      Telephone_work
      Telephone_alt
      Telephone_mobile
      Pager
      Fax
      PostalAddress_main {
        CountryCode
        Municipality
        Region
        AddressLine
        PostalCode
        __typename
      }
      PostalAddress_alt {
        CountryCode
        Municipality
        Region
        AddressLine
        PostalCode
        __typename
      }
      __typename
    }
    DOB
    EducationHistory {
      StartDate
      EndDate
      MeasureValue
      Major
      SchoolUnit
      Degree {
        degreeType
        DegreeName
        DegreeDate
        __typename
      }
      LocationSummary {
        CountryCode
        Municipality
        Region
        AddressLine
        PostalCode
        __typename
      }
      SchoolName
      schoolType
      Comments
      __typename
    }
    EmploymentHistory {
      StartDate
      EndDate
      LocationSummary {
        CountryCode
        Municipality
        Region
        AddressLine
        PostalCode
        __typename
      }
      InternetDomainName
      EmployerOrgName
      employerOrgType
      PositionType
      MonthsOfWork
      TimelineNumber
      Title
      ReasonForLeaving
      OrgIndustry {
        IndustryDescription
        primaryIndicator
        __typename
      }
      JobArea
      JobGrade
      Project
      OrgName
      Description
      __typename
    }
    ExecutiveSummary
    Hobbies
    LicensesAndCertifications {
      IssuingAuthority {
        IssuingAuthorityName
        countryCode
        __typename
      }
      Id
      EffectiveDate {
        ValidFrom
        FirstIssuedDate
        ValidTo
        __typename
      }
      LicensesOrCertificationName
      Description
      __typename
    }
    Languages {
      CompetencyId {
        idOwner
        id
        __typename
      }
      Proficiency
      Speak
      LanguageCode
      Write
      Read
      __typename
    }
    lang
    LegalDocuments {
      IssueCountryCode
      IssueAuthority
      IssueDate
      Number
      IssueLocationSummary {
        CountryCode
        Municipality
        Region
        AddressLine
        PostalCode
        __typename
      }
      type
      __typename
    }
    MaritalStatus
    Nationality
    OtherInfo
    PersonName {
      FormattedName
      Title
      Suffix
      FamilyName
      GivenName
      PreferredGivenName
      MiddleName
      sex
      __typename
    }
    PlaceOfBirth {
      CountryCode
      Municipality
      Region
      AddressLine
      PostalCode
      __typename
    }
    PoliticalStatus
    PreferredLocation
    PreferredPosition
    PreferredPositionType
    PreferredTypeOfHours
    ProjectHistory {
      StartDate
      EndDate
      LocationSummary {
        CountryCode
        Municipality
        Region
        AddressLine
        PostalCode
        __typename
      }
      InternetDomainName
      EmployerOrgName
      employerOrgType
      PositionType
      MonthsOfWork
      TimelineNumber
      Title
      ReasonForLeaving
      OrgIndustry {
        IndustryDescription
        primaryIndicator
        __typename
      }
      JobArea
      JobGrade
      Project
      OrgName
      Description
      __typename
    }
    PublicationHistory {
      Comments
      content
      Issue
      JournalOrSerialName
      Volume
      PageNumber
      Name {
        FormattedName
        role
        __typename
      }
      Title
      PublicationDate
      __typename
    }
    Race
    References {
      CompanyName
      PersonName {
        FormattedName
        Title
        Suffix
        FamilyName
        GivenName
        PreferredGivenName
        MiddleName
        sex
        __typename
      }
      ContactMethod {
        InternetEmailAddress_main
        InternetEmailAddress_alt
        Telephone_home
        Telephone_work
        Telephone_alt
        Telephone_mobile
        Pager
        Fax
        __typename
      }
      PositionTitle
      __typename
    }
    RegisteredResidence {
      CountryCode
      Municipality
      Region
      AddressLine
      PostalCode
      __typename
    }
    Religion
    RevisionDate
    Salary_desired {
      currency
      amount
      hiamount
      period
      __typename
    }
    Salary_current {
      currency
      amount
      hiamount
      period
      __typename
    }
    WillRelocate
    RawData
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCandidateResumeQueryVariables,
  APITypes.GetCandidateResumeQuery
>;
export const listCandidateResumes = /* GraphQL */ `query ListCandidateResumes(
  $filter: ModelCandidateResumeFilterInput
  $limit: Int
  $nextToken: String
) {
  listCandidateResumes(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      owner
      submitted
      verified
      ExperienceSummary {
        TotalYearsOfManagementWorkExperience
        TotalYearsOfLowLevelManagementWorkExperience
        TotalMonthsOfWorkExperience
        ExecutiveBrief
        TotalMonthsOfLowLevelManagementWorkExperience
        TotalMonthsOfManagementWorkExperience
        TotalYearsOfMidLevelManagementWorkExperience
        TotalMonthsOfMidLevelManagementWorkExperience
        TotalYearsOfSeniorManagementWorkExperience
        TotalMonthsOfSeniorManagementWorkExperience
        ManagementRecord
        HighestEducationalLevel
        TotalYearsOfWorkExperience
        __typename
      }
      Achievements
      Available
      Competency {
        skillLevel
        skillProficiency
        Grade
        skillName
        description
        auth
        skillCount
        lastUsed
        skillAliasArray
        __typename
      }
      ContactMethod {
        InternetEmailAddress_main
        InternetEmailAddress_alt
        Telephone_home
        Telephone_work
        Telephone_alt
        Telephone_mobile
        Pager
        Fax
        __typename
      }
      DOB
      EducationHistory {
        StartDate
        EndDate
        MeasureValue
        Major
        SchoolUnit
        SchoolName
        schoolType
        Comments
        __typename
      }
      EmploymentHistory {
        StartDate
        EndDate
        InternetDomainName
        EmployerOrgName
        employerOrgType
        PositionType
        MonthsOfWork
        TimelineNumber
        Title
        ReasonForLeaving
        JobArea
        JobGrade
        Project
        OrgName
        Description
        __typename
      }
      ExecutiveSummary
      Hobbies
      LicensesAndCertifications {
        Id
        LicensesOrCertificationName
        Description
        __typename
      }
      Languages {
        Proficiency
        Speak
        LanguageCode
        Write
        Read
        __typename
      }
      lang
      LegalDocuments {
        IssueCountryCode
        IssueAuthority
        IssueDate
        Number
        type
        __typename
      }
      MaritalStatus
      Nationality
      OtherInfo
      PersonName {
        FormattedName
        Title
        Suffix
        FamilyName
        GivenName
        PreferredGivenName
        MiddleName
        sex
        __typename
      }
      PlaceOfBirth {
        CountryCode
        Municipality
        Region
        AddressLine
        PostalCode
        __typename
      }
      PoliticalStatus
      PreferredLocation
      PreferredPosition
      PreferredPositionType
      PreferredTypeOfHours
      ProjectHistory {
        StartDate
        EndDate
        InternetDomainName
        EmployerOrgName
        employerOrgType
        PositionType
        MonthsOfWork
        TimelineNumber
        Title
        ReasonForLeaving
        JobArea
        JobGrade
        Project
        OrgName
        Description
        __typename
      }
      PublicationHistory {
        Comments
        content
        Issue
        JournalOrSerialName
        Volume
        PageNumber
        Title
        PublicationDate
        __typename
      }
      Race
      References {
        CompanyName
        PositionTitle
        __typename
      }
      RegisteredResidence {
        CountryCode
        Municipality
        Region
        AddressLine
        PostalCode
        __typename
      }
      Religion
      RevisionDate
      Salary_desired {
        currency
        amount
        hiamount
        period
        __typename
      }
      Salary_current {
        currency
        amount
        hiamount
        period
        __typename
      }
      WillRelocate
      RawData
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCandidateResumesQueryVariables,
  APITypes.ListCandidateResumesQuery
>;
export const getTimesheet = /* GraphQL */ `query GetTimesheet($id: ID!) {
  getTimesheet(id: $id) {
    id
    owner
    user {
      id
      email
      name
      userType
      odooId
      customerId
      __typename
    }
    contractId
    employeeId
    employeeName
    customerId
    customerName
    jobId
    status
    state
    submitted
    submittedBy
    submittedByName
    submittedDate
    approver1
    approver1Name
    approver1Token
    approved1
    approved1By
    approved1ByName
    approved1Date
    approver2
    approver2Name
    approver2Token
    approved2
    approved2By
    approved2ByName
    approved2Date
    fromDate
    toDate
    description
    entries {
      date
      type
      leaveType
      leaveId
      __typename
    }
    managersComments {
      date
      managerId
      message
      __typename
    }
    statusChanges {
      date
      userId
      status
      message
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTimesheetQueryVariables,
  APITypes.GetTimesheetQuery
>;
export const listTimesheets = /* GraphQL */ `query ListTimesheets(
  $filter: ModelTimesheetFilterInput
  $limit: Int
  $nextToken: String
) {
  listTimesheets(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      owner
      user {
        id
        email
        name
        userType
        odooId
        customerId
        __typename
      }
      contractId
      employeeId
      employeeName
      customerId
      customerName
      jobId
      status
      state
      submitted
      submittedBy
      submittedByName
      submittedDate
      approver1
      approver1Name
      approver1Token
      approved1
      approved1By
      approved1ByName
      approved1Date
      approver2
      approver2Name
      approver2Token
      approved2
      approved2By
      approved2ByName
      approved2Date
      fromDate
      toDate
      description
      entries {
        date
        type
        leaveType
        leaveId
        __typename
      }
      managersComments {
        date
        managerId
        message
        __typename
      }
      statusChanges {
        date
        userId
        status
        message
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTimesheetsQueryVariables,
  APITypes.ListTimesheetsQuery
>;
export const timesheetsByContractor = /* GraphQL */ `query TimesheetsByContractor(
  $owner: String
  $statusFromDate: ModelTimesheetByContractorCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelTimesheetFilterInput
  $limit: Int
  $nextToken: String
) {
  timesheetsByContractor(
    owner: $owner
    statusFromDate: $statusFromDate
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      owner
      user {
        id
        email
        name
        userType
        odooId
        customerId
        __typename
      }
      contractId
      employeeId
      employeeName
      customerId
      customerName
      jobId
      status
      state
      submitted
      submittedBy
      submittedByName
      submittedDate
      approver1
      approver1Name
      approver1Token
      approved1
      approved1By
      approved1ByName
      approved1Date
      approver2
      approver2Name
      approver2Token
      approved2
      approved2By
      approved2ByName
      approved2Date
      fromDate
      toDate
      description
      entries {
        date
        type
        leaveType
        leaveId
        __typename
      }
      managersComments {
        date
        managerId
        message
        __typename
      }
      statusChanges {
        date
        userId
        status
        message
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.TimesheetsByContractorQueryVariables,
  APITypes.TimesheetsByContractorQuery
>;
export const timesheetsByContractorAndDate = /* GraphQL */ `query TimesheetsByContractorAndDate(
  $owner: String
  $fromDate: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelTimesheetFilterInput
  $limit: Int
  $nextToken: String
) {
  timesheetsByContractorAndDate(
    owner: $owner
    fromDate: $fromDate
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      owner
      user {
        id
        email
        name
        userType
        odooId
        customerId
        __typename
      }
      contractId
      employeeId
      employeeName
      customerId
      customerName
      jobId
      status
      state
      submitted
      submittedBy
      submittedByName
      submittedDate
      approver1
      approver1Name
      approver1Token
      approved1
      approved1By
      approved1ByName
      approved1Date
      approver2
      approver2Name
      approver2Token
      approved2
      approved2By
      approved2ByName
      approved2Date
      fromDate
      toDate
      description
      entries {
        date
        type
        leaveType
        leaveId
        __typename
      }
      managersComments {
        date
        managerId
        message
        __typename
      }
      statusChanges {
        date
        userId
        status
        message
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.TimesheetsByContractorAndDateQueryVariables,
  APITypes.TimesheetsByContractorAndDateQuery
>;
export const timesheetsByEmployee = /* GraphQL */ `query TimesheetsByEmployee(
  $employeeId: Int
  $fromDate: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelTimesheetFilterInput
  $limit: Int
  $nextToken: String
) {
  timesheetsByEmployee(
    employeeId: $employeeId
    fromDate: $fromDate
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      owner
      user {
        id
        email
        name
        userType
        odooId
        customerId
        __typename
      }
      contractId
      employeeId
      employeeName
      customerId
      customerName
      jobId
      status
      state
      submitted
      submittedBy
      submittedByName
      submittedDate
      approver1
      approver1Name
      approver1Token
      approved1
      approved1By
      approved1ByName
      approved1Date
      approver2
      approver2Name
      approver2Token
      approved2
      approved2By
      approved2ByName
      approved2Date
      fromDate
      toDate
      description
      entries {
        date
        type
        leaveType
        leaveId
        __typename
      }
      managersComments {
        date
        managerId
        message
        __typename
      }
      statusChanges {
        date
        userId
        status
        message
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.TimesheetsByEmployeeQueryVariables,
  APITypes.TimesheetsByEmployeeQuery
>;
export const timesheetsByCustomer = /* GraphQL */ `query TimesheetsByCustomer(
  $customerId: String
  $statusFromDate: ModelTimesheetByCustomerCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelTimesheetFilterInput
  $limit: Int
  $nextToken: String
) {
  timesheetsByCustomer(
    customerId: $customerId
    statusFromDate: $statusFromDate
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      owner
      user {
        id
        email
        name
        userType
        odooId
        customerId
        __typename
      }
      contractId
      employeeId
      employeeName
      customerId
      customerName
      jobId
      status
      state
      submitted
      submittedBy
      submittedByName
      submittedDate
      approver1
      approver1Name
      approver1Token
      approved1
      approved1By
      approved1ByName
      approved1Date
      approver2
      approver2Name
      approver2Token
      approved2
      approved2By
      approved2ByName
      approved2Date
      fromDate
      toDate
      description
      entries {
        date
        type
        leaveType
        leaveId
        __typename
      }
      managersComments {
        date
        managerId
        message
        __typename
      }
      statusChanges {
        date
        userId
        status
        message
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.TimesheetsByCustomerQueryVariables,
  APITypes.TimesheetsByCustomerQuery
>;
export const timesheetsByStatus = /* GraphQL */ `query TimesheetsByStatus(
  $status: TimesheetStatus
  $fromDate: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelTimesheetFilterInput
  $limit: Int
  $nextToken: String
) {
  timesheetsByStatus(
    status: $status
    fromDate: $fromDate
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      owner
      user {
        id
        email
        name
        userType
        odooId
        customerId
        __typename
      }
      contractId
      employeeId
      employeeName
      customerId
      customerName
      jobId
      status
      state
      submitted
      submittedBy
      submittedByName
      submittedDate
      approver1
      approver1Name
      approver1Token
      approved1
      approved1By
      approved1ByName
      approved1Date
      approver2
      approver2Name
      approver2Token
      approved2
      approved2By
      approved2ByName
      approved2Date
      fromDate
      toDate
      description
      entries {
        date
        type
        leaveType
        leaveId
        __typename
      }
      managersComments {
        date
        managerId
        message
        __typename
      }
      statusChanges {
        date
        userId
        status
        message
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.TimesheetsByStatusQueryVariables,
  APITypes.TimesheetsByStatusQuery
>;
export const timesheetsByApprover1 = /* GraphQL */ `query TimesheetsByApprover1(
  $approver1: String
  $sortDirection: ModelSortDirection
  $filter: ModelTimesheetFilterInput
  $limit: Int
  $nextToken: String
) {
  timesheetsByApprover1(
    approver1: $approver1
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      owner
      user {
        id
        email
        name
        userType
        odooId
        customerId
        __typename
      }
      contractId
      employeeId
      employeeName
      customerId
      customerName
      jobId
      status
      state
      submitted
      submittedBy
      submittedByName
      submittedDate
      approver1
      approver1Name
      approver1Token
      approved1
      approved1By
      approved1ByName
      approved1Date
      approver2
      approver2Name
      approver2Token
      approved2
      approved2By
      approved2ByName
      approved2Date
      fromDate
      toDate
      description
      entries {
        date
        type
        leaveType
        leaveId
        __typename
      }
      managersComments {
        date
        managerId
        message
        __typename
      }
      statusChanges {
        date
        userId
        status
        message
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.TimesheetsByApprover1QueryVariables,
  APITypes.TimesheetsByApprover1Query
>;
export const timesheetsByApprover2 = /* GraphQL */ `query TimesheetsByApprover2(
  $approver2: String
  $sortDirection: ModelSortDirection
  $filter: ModelTimesheetFilterInput
  $limit: Int
  $nextToken: String
) {
  timesheetsByApprover2(
    approver2: $approver2
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      owner
      user {
        id
        email
        name
        userType
        odooId
        customerId
        __typename
      }
      contractId
      employeeId
      employeeName
      customerId
      customerName
      jobId
      status
      state
      submitted
      submittedBy
      submittedByName
      submittedDate
      approver1
      approver1Name
      approver1Token
      approved1
      approved1By
      approved1ByName
      approved1Date
      approver2
      approver2Name
      approver2Token
      approved2
      approved2By
      approved2ByName
      approved2Date
      fromDate
      toDate
      description
      entries {
        date
        type
        leaveType
        leaveId
        __typename
      }
      managersComments {
        date
        managerId
        message
        __typename
      }
      statusChanges {
        date
        userId
        status
        message
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.TimesheetsByApprover2QueryVariables,
  APITypes.TimesheetsByApprover2Query
>;
export const searchTimesheets = /* GraphQL */ `query SearchTimesheets(
  $filter: SearchableTimesheetFilterInput
  $sort: SearchableTimesheetSortInput
  $limit: Int
  $nextToken: String
  $from: Int
) {
  searchTimesheets(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
  ) {
    items {
      id
      owner
      user {
        id
        email
        name
        userType
        odooId
        customerId
        __typename
      }
      contractId
      employeeId
      employeeName
      customerId
      customerName
      jobId
      status
      state
      submitted
      submittedBy
      submittedByName
      submittedDate
      approver1
      approver1Name
      approver1Token
      approved1
      approved1By
      approved1ByName
      approved1Date
      approver2
      approver2Name
      approver2Token
      approved2
      approved2By
      approved2ByName
      approved2Date
      fromDate
      toDate
      description
      entries {
        date
        type
        leaveType
        leaveId
        __typename
      }
      managersComments {
        date
        managerId
        message
        __typename
      }
      statusChanges {
        date
        userId
        status
        message
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchTimesheetsQueryVariables,
  APITypes.SearchTimesheetsQuery
>;
export const getNotification = /* GraphQL */ `query GetNotification($id: ID!) {
  getNotification(id: $id) {
    id
    status
    date
    user
    template
    parameters
    timesheetId
    datePartition
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetNotificationQueryVariables,
  APITypes.GetNotificationQuery
>;
export const listNotifications = /* GraphQL */ `query ListNotifications(
  $filter: ModelNotificationFilterInput
  $limit: Int
  $nextToken: String
) {
  listNotifications(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      status
      date
      user
      template
      parameters
      timesheetId
      datePartition
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListNotificationsQueryVariables,
  APITypes.ListNotificationsQuery
>;
export const notificationsByTimesheet = /* GraphQL */ `query NotificationsByTimesheet(
  $timesheetId: String
  $userDate: ModelNotificationByTimesheetCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelNotificationFilterInput
  $limit: Int
  $nextToken: String
) {
  notificationsByTimesheet(
    timesheetId: $timesheetId
    userDate: $userDate
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      status
      date
      user
      template
      parameters
      timesheetId
      datePartition
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.NotificationsByTimesheetQueryVariables,
  APITypes.NotificationsByTimesheetQuery
>;
export const notificationsByStatus = /* GraphQL */ `query NotificationsByStatus(
  $status: NotificationStatus
  $date: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelNotificationFilterInput
  $limit: Int
  $nextToken: String
) {
  notificationsByStatus(
    status: $status
    date: $date
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      status
      date
      user
      template
      parameters
      timesheetId
      datePartition
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.NotificationsByStatusQueryVariables,
  APITypes.NotificationsByStatusQuery
>;
export const notificationsByUser = /* GraphQL */ `query NotificationsByUser(
  $user: String
  $date: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelNotificationFilterInput
  $limit: Int
  $nextToken: String
) {
  notificationsByUser(
    user: $user
    date: $date
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      status
      date
      user
      template
      parameters
      timesheetId
      datePartition
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.NotificationsByUserQueryVariables,
  APITypes.NotificationsByUserQuery
>;
export const notificationsByDate = /* GraphQL */ `query NotificationsByDate(
  $datePartition: String
  $date: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelNotificationFilterInput
  $limit: Int
  $nextToken: String
) {
  notificationsByDate(
    datePartition: $datePartition
    date: $date
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      status
      date
      user
      template
      parameters
      timesheetId
      datePartition
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.NotificationsByDateQueryVariables,
  APITypes.NotificationsByDateQuery
>;
export const getRequest = /* GraphQL */ `query GetRequest($id: ID!) {
  getRequest(id: $id) {
    id
    owner
    user {
      id
      email
      name
      userType
      odooId
      customerId
      __typename
    }
    employeeId
    employeeName
    status
    type
    requestDate
    entityName
    notes
    drivingInstitureName
    emirate
    country
    dateFrom
    dateTo
    expectedAmount
    receivedAmount
    months
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetRequestQueryVariables,
  APITypes.GetRequestQuery
>;
export const listRequests = /* GraphQL */ `query ListRequests(
  $filter: ModelRequestFilterInput
  $limit: Int
  $nextToken: String
) {
  listRequests(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      owner
      user {
        id
        email
        name
        userType
        odooId
        customerId
        __typename
      }
      employeeId
      employeeName
      status
      type
      requestDate
      entityName
      notes
      drivingInstitureName
      emirate
      country
      dateFrom
      dateTo
      expectedAmount
      receivedAmount
      months
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListRequestsQueryVariables,
  APITypes.ListRequestsQuery
>;
export const requestsByContractor = /* GraphQL */ `query RequestsByContractor(
  $owner: String
  $requestDate: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelRequestFilterInput
  $limit: Int
  $nextToken: String
) {
  requestsByContractor(
    owner: $owner
    requestDate: $requestDate
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      owner
      user {
        id
        email
        name
        userType
        odooId
        customerId
        __typename
      }
      employeeId
      employeeName
      status
      type
      requestDate
      entityName
      notes
      drivingInstitureName
      emirate
      country
      dateFrom
      dateTo
      expectedAmount
      receivedAmount
      months
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.RequestsByContractorQueryVariables,
  APITypes.RequestsByContractorQuery
>;
export const getContractorActivity = /* GraphQL */ `query GetContractorActivity($id: ID!) {
  getContractorActivity(id: $id) {
    id
    owner
    timesheetId
    user {
      id
      email
      name
      userType
      odooId
      customerId
      __typename
    }
    employeeId
    employeeName
    customerId
    customerName
    description
    assignedBy
    team
    status
    startDate
    endDate
    document
    createdAt
    updatedAt
    timesheet {
      id
      owner
      user {
        id
        email
        name
        userType
        odooId
        customerId
        __typename
      }
      contractId
      employeeId
      employeeName
      customerId
      customerName
      jobId
      status
      state
      submitted
      submittedBy
      submittedByName
      submittedDate
      approver1
      approver1Name
      approver1Token
      approved1
      approved1By
      approved1ByName
      approved1Date
      approver2
      approver2Name
      approver2Token
      approved2
      approved2By
      approved2ByName
      approved2Date
      fromDate
      toDate
      description
      entries {
        date
        type
        leaveType
        leaveId
        __typename
      }
      managersComments {
        date
        managerId
        message
        __typename
      }
      statusChanges {
        date
        userId
        status
        message
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetContractorActivityQueryVariables,
  APITypes.GetContractorActivityQuery
>;
export const listContractorActivitys = /* GraphQL */ `query ListContractorActivitys(
  $filter: ModelContractorActivityFilterInput
  $limit: Int
  $nextToken: String
) {
  listContractorActivitys(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      owner
      timesheetId
      user {
        id
        email
        name
        userType
        odooId
        customerId
        __typename
      }
      employeeId
      employeeName
      customerId
      customerName
      description
      assignedBy
      team
      status
      startDate
      endDate
      document
      createdAt
      updatedAt
      timesheet {
        id
        owner
        contractId
        employeeId
        employeeName
        customerId
        customerName
        jobId
        status
        state
        submitted
        submittedBy
        submittedByName
        submittedDate
        approver1
        approver1Name
        approver1Token
        approved1
        approved1By
        approved1ByName
        approved1Date
        approver2
        approver2Name
        approver2Token
        approved2
        approved2By
        approved2ByName
        approved2Date
        fromDate
        toDate
        description
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListContractorActivitysQueryVariables,
  APITypes.ListContractorActivitysQuery
>;
export const activitiesByTimesheet = /* GraphQL */ `query ActivitiesByTimesheet(
  $timesheetId: ID
  $sortDirection: ModelSortDirection
  $filter: ModelContractorActivityFilterInput
  $limit: Int
  $nextToken: String
) {
  activitiesByTimesheet(
    timesheetId: $timesheetId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      owner
      timesheetId
      user {
        id
        email
        name
        userType
        odooId
        customerId
        __typename
      }
      employeeId
      employeeName
      customerId
      customerName
      description
      assignedBy
      team
      status
      startDate
      endDate
      document
      createdAt
      updatedAt
      timesheet {
        id
        owner
        contractId
        employeeId
        employeeName
        customerId
        customerName
        jobId
        status
        state
        submitted
        submittedBy
        submittedByName
        submittedDate
        approver1
        approver1Name
        approver1Token
        approved1
        approved1By
        approved1ByName
        approved1Date
        approver2
        approver2Name
        approver2Token
        approved2
        approved2By
        approved2ByName
        approved2Date
        fromDate
        toDate
        description
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ActivitiesByTimesheetQueryVariables,
  APITypes.ActivitiesByTimesheetQuery
>;
export const getFeatureFlag = /* GraphQL */ `query GetFeatureFlag($id: ID!) {
  getFeatureFlag(id: $id) {
    id
    name
    category
    enabled
    condition
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetFeatureFlagQueryVariables,
  APITypes.GetFeatureFlagQuery
>;
export const listFeatureFlags = /* GraphQL */ `query ListFeatureFlags(
  $filter: ModelFeatureFlagFilterInput
  $limit: Int
  $nextToken: String
) {
  listFeatureFlags(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      category
      enabled
      condition
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListFeatureFlagsQueryVariables,
  APITypes.ListFeatureFlagsQuery
>;
